import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { HideScrollbar } from '../../../global/commonStyle';

interface Props {
  height?: string;
  maxWidth?: string;
  isDisabled?: boolean;
}
// text area
export const TextAreaField = styled.textarea<Props>`
  ${Typography.body_lg}
  background-color: var(--background-primary);
  color: var(--text-primary);
  box-shadow: var(--border);
  border: none;
  border-radius: var(--border-radius-8);
  padding: var(--space-8) var(--space-8) var(--space-8) var(--space-12);
  resize: none;
  /* Use CSS custom property from parent if height prop is not provided */
  height: ${({ height }) => height || 'var(--textarea-height, auto)'};
  max-width: ${({ maxWidth }) => maxWidth};
  font-family: unset;
  &:disabled {
    cursor: not-allowed;
    color: var(--text-muted);
    &::placeholder {
      color: var(--text-muted);
    }
    &:hover {
      box-shadow: var(--border);
    }
  }
  &:hover {
    box-shadow: var(--border-hover);
  }
  ${HideScrollbar}
  ::placeholder {
    ${Typography.body_lg}
    color: var(--text-placeholder);
  }
  &:focus-visible {
    outline: none;
    box-shadow: var(--border-active);
  }
`;
